module.exports = __webpack_public_path__ + "static/media/view1.05658da4.jpg";